<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('orders.notFoundOrdersTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            add_not_found_order: 'add_not_found_order'
          }"
          :hideBranch="true"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :enableCustomerSearchSuggestions="true"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :addNotFoundOrderButton="true"
          :openAddNotFoundOrderModal="openAddNotFoundOrderModal"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <!-- Status filter + Search button - hidden for later use, keep tableData.statuses/getResults wiring intact
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              sm9
              md9
              lg6
              class="px-2"
            >
              <v-select
                :items="statusList"
                v-model="tableData.statuses"
                :label="$t('columns.statuses')"
                multiple
                chips
                hide-details
                deletable-chips
              />
            </v-flex>
            <v-flex
              xs12
              sm3
              md3
              lg6
              class="px-2 pt-3"
            >
              <v-btn
                color="primary"
                style="height: auto; transition: all 0.1s"
                class="pa-1"
                depressed
                small
                @click="getResults()"
              >
                Search
              </v-btn>
            </v-flex>
          </v-layout>
          -->
          <datatable
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.not_found_order_id"
                :class="{
                  'red lighten-2': r.status == 2,
                  'green lighten-2': r.status == 3,
                  'blue lighten-2': r.status == 4,
                  'grey lighten-2': r.status == 5,
                }"
              >
                <td>{{ r.not_found_order_id }}</td>
                <td>{{ r.status_name }}</td>
                <td>{{ r.product_name }}</td>
                <td>{{ r.item_weight }}</td>
                <td>{{ r.track_number }}</td>
                <td>{{ r.order_number }}</td>
                <td>{{ r.full_name }}</td>
                <td>{{ r.created_at | moment('YYYY-MM-DD hh:mm a') }}</td>
                <td>
                  <div class="d-flex">
                    <a
                      v-if="$_has_perm('edit_not_found_order') && r.status == 1"
                      :tooltip="$t('common.edit')"
                      class="mx-1"
                      @click="edit(r)"
                    >
                      <v-icon color="blue darken-2">edit</v-icon>
                    </a>
                    <a
                      v-if="$_has_perm('trash_not_found_order') && r.status == 1"
                      :tooltip="$t('orders.trashTooltip')"
                      class="mx-1"
                      @click="trash(r.not_found_order_id)"
                    >
                      <i
                        class="fa fa-trash error--text"
                        style="font-size: 20px"
                      />
                    </a>
                    <a
                      v-if="$_has_perm('allow_to_send_not_found_order') && r.status == 1"
                      :tooltip="$t('orders.allowToSendTooltip')"
                      class="mx-1"
                      @click="allowToSend(r.not_found_order_id)"
                    >
                      <i
                        class="fa fa-check success--text"
                        style="font-size: 20px"
                      />
                    </a>
                    <a
                      v-if="$_has_perm('sent_not_found_order') && r.status == 3"
                      :tooltip="$t('orders.sendTooltip')"
                      class="mx-1"
                      @click="send(r.not_found_order_id)"
                    >
                      <i
                        class="fa fa-send warning--text"
                        style="font-size: 20px"
                      />
                    </a>
                    <a
                      v-if="$_has_perm('convert_to_order_not_found_order') && r.status == 4"
                      :tooltip="$t('orders.convertToOrderTooltip')"
                      class="mx-1"
                      @click="convertToOrder(r)"
                    >
                      <i
                        class="fa fa-plus purple--text"
                        style="font-size: 20px"
                      />
                    </a>
                  </div>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <add-edit-not-found-order
            :addEditNotFoundOrderModal="addEditNotFoundOrderModal"
            :formData="formData"
            :isUpdate="isUpdate"
            @close="addEditNotFoundOrderModal = false"
            @resetTable="resetGetResults()"
          />

          <convert-to-order
            :convertToOrderModal="convertToOrderModal"
            :formData="formData"
            :customers="customers"
            :warehouses="warehouses"
            @close="convertToOrderModal = false"
            @resetTable="resetGetResults()"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import addEditNotFoundOrder from './addEditNotFoundOrder'
import axios from 'axios'
import swal from 'sweetalert'
import convertToOrder from './convertToOrder.vue'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    addEditNotFoundOrder,
    convertToOrder
  },

  mounted() {
    this.perPageFix()
    this.getCustomer()
    this.getWarehouses()
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    let sortOrders = {}
    let columns = [
      { label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'not_found_order_id' },
      { label: this.$t('columns.status'), text: this.$t('columns.status'), value: '2', sortable: true, searchable: true, name: 'status_name' },
      { label: this.$t('columns.productName'), text: this.$t('columns.productName'), value: '3', sortable: true, searchable: true, name: 'product_name' },
      { label: this.$t('columns.weight'), text: this.$t('columns.weight'), value: '4', sortable: true, searchable: true, name: 'item_weight' },
      { label: this.$t('columns.trackNumber'), text: this.$t('columns.trackNumber'), value: '5', sortable: true, searchable: true, name: 'track_number' },
      { label: this.$t('columns.orderNumber'), text: this.$t('columns.orderNumber'), value: '5', sortable: true, searchable: true, name: 'order_number' },
      { label: this.$t('user.staffTitle'), text: this.$t('user.staffTitle'), value: '6', sortable: true, searchable: true, name: 'full_name' },
      { label: this.$t('columns.createDate'), text: this.$t('columns.createDate'), value: '7', sortable: true, searchable: true, name: 'created_at' }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      url: 'api/not-found-order',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditNotFoundOrderModal: false,
      convertToOrderModal: false,
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      customers: [],
      warehouses: [],
      columns: columns,
      statusList: [
        { text: this.$t('common.new'), value: 1 },
        { text: this.$t('orders.trashTooltip'), value: 2 },
        { text: this.$t('orders.allowToSendTooltip'), value: 3 },
        { text: this.$t('orders.sentStatusTitle'), value: 4 },
        { text: this.$t('orders.convertedToOrderStatus'), value: 5 }
      ],
      sortKey: 'not_found_order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'not_found_order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    getCustomer() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.data.forEach((c) => {
            this.customers.push({
              text: c.full_name + ' - Tel: ' + [c.phone_number, c.phone_number_2].filter(Boolean).join(' / '),
              value: c.user_id
            })
          })
        })
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.data.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types })
          })
        })
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    openAddNotFoundOrderModal() {
      this.formData = {}
      this.isUpdate = false
      this.addEditNotFoundOrderModal = true
    },

    edit(data) {
      this.formData = { ...data }
      this.isUpdate = true
      this.addEditNotFoundOrderModal = true
    },

    trash(id) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(`api/not-found-order/${id}/trash`, {}, { headers: { Authorization: 'Bearer ' + token } })
            .then(() => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
        }
      })
    },

    allowToSend(id) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(`api/not-found-order/${id}/allow-to-send`, {}, { headers: { Authorization: 'Bearer ' + token } })
            .then(() => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
        }
      })
    },

    send(id) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(`api/not-found-order/${id}/send`, {}, { headers: { Authorization: 'Bearer ' + token } })
            .then(() => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
        }
      })
    },

    convertToOrder(data) {
      this.formData = { ...data }
      this.convertToOrderModal = true
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { console.error(errors) })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'not_found_order_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'not_found_order_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    resetGetResults2() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'not_found_order_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'not_found_order_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/notFoundOrder/notFoundOrders.vue